<div class="input-radio-container">
  @if (label()) {
    <label class="radio-group-label">{{ label() }}</label>
  }
  @for (option of options(); track option.value) {
    <div class="input-radio-wrapper">
      <p-radiobutton
        [name]="'radio-group'"
        [value]="option.value"
        [inputId]="'radio-' + option.value"
        [(ngModel)]="value"
        [disabled]="disabled()"
        (onClick)="onRadioInputChange(option)">
      </p-radiobutton>
      <label [for]="'radio-' + option.value" class="radio-option-label">{{ option.label }}</label>
    </div>
  }
</div>
